/* Merge className strings. The rulebook's rule is that a caller's className MERGES with a component's own defaults rather than replacing them — the existing... */
export const cn = (...parts) => parts.filter(Boolean).join(" ");

export default cn;
